import App from "../components/App";
const Router = () => {
  return <App />;
};

export default Router;
